"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sensorType = exports.mostCountType = exports.itemSizeType = exports.VectorType = exports.ConnectPipeType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _paulCorePackage = require("paul-core-package");
var _constants = require("../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ConnectPipeType = exports.ConnectPipeType = _propTypes.default.shape({
  highlightsType: _propTypes.default.oneOf(Object.values(_constants.pipesTypes)),
  display: _propTypes.default.bool
});
const VectorType = exports.VectorType = _propTypes.default.arrayOf((propValue, key, componentName, location, propFullName) => {
  if (propValue.length !== 3) {
    return new Error("Invalid prop ".concat(propFullName, " supplied to ").concat(componentName, ". Validation failed. An array can contain only 3 values"));
  }
  if (typeof propValue[key] !== 'number') {
    return new Error("Invalid prop ".concat(propFullName, " supplied to ").concat(componentName, ". Validation failed. The value (index ").concat(key, ") is not of type number"));
  }
  return null;
});
const itemSizeType = exports.itemSizeType = _propTypes.default.number;
const mostCountType = exports.mostCountType = _propTypes.default.number;
const sensorType = exports.sensorType = _propTypes.default.oneOf([_paulCorePackage.constants.sensorTypes.temperatureSensor, _paulCorePackage.constants.sensorTypes.smartValve, _paulCorePackage.constants.sensorTypes.energyValve, _paulCorePackage.constants.sensorTypes.pump]);